/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'android': {
    width: 13,
    height: 15,
    viewBox: '0 0 13 15',
    data: '<path pid="0" d="M1.027 4.9c-.55 0-.95.4-.95.9v3.9c0 .5.4.9.9.9h.05c.5 0 .9-.4.9-.9V5.8c0-.5-.4-.9-.9-.9zm1.3 6.3c0 .45.35.8.8.8h.9v2.1c0 .5.4.9.9.9h.05c.5 0 .9-.4.9-.9V12h1.25v2.1c0 .5.4.9.9.9h.05c.5 0 .9-.4.9-.9V12h.9c.45 0 .8-.35.8-.8V5.05h-8.35v6.15zm6.2-9.9l.7-1.1c.05-.05 0-.15-.05-.2-.05 0-.15 0-.2.05l-.7 1.1c-.55-.2-1.15-.35-1.8-.35-.65 0-1.25.1-1.8.35l-.7-1.1c-.05-.05-.15-.05-.2-.05-.1.05-.1.15-.05.25l.7 1.1c-1.25.55-2.1 1.75-2.1 3.05v.25h8.3V4.4c0-1.3-.85-2.5-2.1-3.1zm-4 1.95c-.2 0-.4-.2-.4-.4s.2-.4.4-.4.4.2.4.4-.15.4-.4.4zm3.9 0c-.2 0-.4-.2-.4-.4s.2-.4.4-.4.4.2.4.4-.2.4-.4.4zm3.55 1.65c-.55 0-.95.4-.95.9v3.9c0 .5.4.9.9.9h.05c.5 0 .9-.4.9-.9V5.8c0-.5-.4-.9-.9-.9z" _fill="#868486" fill-rule="nonzero"/>'
  }
})
